<template>
  <div>
    <div v-if="invoiceList.length">
      <b-table
        id="invoices"
        stacked="sm"
        :per-page="paginationData.perPage"
        :current-page="paginationData.currentPage"
        hover
        :fields="fields"
        :items="invoiceList"
      >
        <template slot="HEAD_status">
          Status
          <i v-b-tooltip.hover title="Status for oppgjør" class="fa fa-info-circle hoverable"></i>
        </template>

        <template slot="HEAD_download">
          Last ned
          <i
            v-b-tooltip.hover
            title="Last ned bilag for oppgjøret"
            class="fa fa-info-circle hoverable"
          ></i>
        </template>

        <template slot="HEAD_total">
          Total
          <i
            v-b-tooltip.hover
            title="Utsalgspris - provisjon(eks. mva)"
            class="fa fa-info-circle hoverable"
          ></i>
        </template>

        <template slot="HEAD_dato">
          Dato
          <i
            v-b-tooltip.hover
            title="Måneden oppgjøret ble produsert"
            class="fa fa-info-circle hoverable"
          ></i>
        </template>
        <template slot="dato" slot-scope="data">
          {{ formatInvoiceDate(data.value) }}
        </template>
        <template slot="total" slot-scope="data">
          {{ parseInt(data.value).toFixed(2) }} kr
        </template>
        <template slot="download" slot-scope="{ item }">
          <a href="#" @click.prevent="downloadInvoice(item.id)"><i class="fa fa-download"></i></a>
        </template>
      </b-table>
      <b-pagination
        v-model="paginationData.currentPage"
        :total-rows="invoiceList.length"
        :per-page="paginationData.perPage"
        aria-controls="invoices"
      ></b-pagination>
    </div>
    <b-alert :show="invoiceList.length === 0" variant="dark" class="text-center">
      <strong>Listen er tom!</strong> Løs inn verdibevis for å motta oppgjør
    </b-alert>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import { format, subDays, parseISO, isBefore } from 'date-fns';
import { nb } from 'date-fns/locale';

export default {
  data() {
    return {
      rootUrl: process.env.VUE_APP_API_URL,
      fields: ['status', 'dato', 'total', { key: 'download', label: 'Last ned' }],
      paginationData: {
        perPage: 10,
        currentPage: 1,
      },
    };
  },
  computed: {
    ...mapGetters({
      invoiceList: 'invoices/invoiceTable',
    }),
  },
  methods: {
    formatInvoiceDate(date) {
      const invoiceDate = parseISO(date);
      if (isBefore(invoiceDate, new Date('2016-09-30 23:59:59'))) {
        return this.formatDate(invoiceDate);
      }
      return format(subDays(invoiceDate, 1), 'MMMM yyyy', { locale: nb });
    },
    downloadInvoice(id) {
      const url = `${this.rootUrl}/invoices/${id}/download`;
      axios.get(url, { responseType: 'arraybuffer' }).then(response => {
        var blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `YouWish-oppgjør-${id}`;
        link.click();
      });
    },
  },
};
</script>
